import { render, staticRenderFns } from "./dayPrice.vue?vue&type=template&id=b4c0990e"
import script from "./dayPrice.vue?vue&type=script&lang=js"
export * from "./dayPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports